import React, { useState } from 'react'
import { useTranslation } from 'react-i18next'

import './styles.scss'
import { Text, colors, Input, Button, Switch } from '../../UIkit'
import { HintIcon } from '../../UIkit/svgs'

const Fiscalization = ({ vendors, baristas, handleUpdate, networkCheckboxIntegrated }) => {
  const { t } = useTranslation()

  const [form, setForm] = useState({
    vendors: vendors
  })
  const [checkboxIntegrated, setCheckboxIntegrated] = useState(networkCheckboxIntegrated)

  const handleSubmit = (e) => {
    e.preventDefault()
    const data = {
      checkboxIntegration: {
        checkboxIntegrated: checkboxIntegrated,
        vendorsAttributes: form.vendors.map(vendor => {
          const newVendor = { ...vendor, baristasAttributes: vendor.baristas }
          delete newVendor.baristas
          return newVendor
        })
      }
    }

    handleUpdate(data)
  }

  const handleSetCheckboxIntegrated = (param) => {
    if ((param === true) && (param === networkCheckboxIntegrated)) {
      const data = {
        checkboxIntegration: {
          checkboxIntegrated: false
        }
      }

      handleUpdate(data)
      setCheckboxIntegrated(false)
    } else {
      setCheckboxIntegrated(!param)
    }
  }

  const updateVendorLicenseKey = (vendorId, newLicenseKey) => {
    setForm(prevForm => {
      const vendorIndex = prevForm.vendors.findIndex(v => v.id === vendorId)
      if (vendorIndex === -1) return prevForm

      const updatedVendors = [...prevForm.vendors]
      updatedVendors[vendorIndex] = {
        ...updatedVendors[vendorIndex],
        checkboxLicenseKey: newLicenseKey
      }

      return {
        ...prevForm,
        vendors: updatedVendors
      }
    })
  }

  const updateBaristaPinCode = (vendorId, baristaId, newPinCode) => {
    setForm(prevForm => {
      const vendorIndex = prevForm.vendors.findIndex(v => v.id === vendorId)
      if (vendorIndex === -1) return prevForm

      const updatedVendors = [...prevForm.vendors]
      updatedVendors[vendorIndex] = {
        ...updatedVendors[vendorIndex],
        baristas: updatedVendors[vendorIndex].baristas.map(barista =>
          barista.id === baristaId ?
            { ...barista, checkboxPinCode: newPinCode } :
            barista
        )
      }

      return {
        ...prevForm,
        vendors: updatedVendors
      }
    })
  }

  const renderVendorsForm = () => (
    form.vendors.map((vendor) => (
      <div key={vendor.id} className='fiscalization__vendor-field'>
        <Text variant='body-main1' color={colors.gray[800]}>
          {vendor.address}
        </Text>
        <div className='fiscalization__input'>
          <Input
            id={vendor.id}
            name='cashRegisterLicenseKey'
            placeholder={t('input:checkboxLicenseKey')}
            value={vendor.checkboxLicenseKey}
            onChange={(e) => updateVendorLicenseKey(vendor.id, e.target.value)}
          />
        </div>
      </div>
    ))
  )

  const renderBaristasForm = () => (
    form.vendors.map((vendor) => vendor.baristas.map((barista) => (
      <div key={barista.id} className='fiscalization__barista-field'>
        <Text variant='body-main1' color={colors.gray[800]}>
          {barista.fullName}
        </Text>
        <div className='fiscalization__input'>
          <Input
            id={barista.id}
            name='pinCode'
            placeholder={t('input:checkboxPinCode')}
            value={barista.checkboxPinCode}
            onChange={(e) => updateBaristaPinCode(vendor.id, barista.id, e.target.value)}
          />
        </div>
      </div>
    )))
  )

  return (
    <div className='fiscalization'>
      <div className='fiscalization__title'>
        <Text variant='body-main1' color={colors.gray[800]}>{t('fiscalization:pageTitle')}</Text>
        <div className='fiscalization__right-title'>
          <div className='fiscalization__switch'>
            <Switch
              index={1}
              checked={checkboxIntegrated}
              onChange={() => handleSetCheckboxIntegrated(checkboxIntegrated)}
            />
            <div className='fiscalization__hint'>
              <HintIcon data-rh-at='bottom' data-rh={t('hint:checkboxIntegration')} />
            </div>
          </div>
        </div>
      </div>
      {checkboxIntegrated
        ? <form className='fiscalization__form' onSubmit={handleSubmit}>
          <div className='fiscalization__main-seciton'>
            <div className='fiscalization__vendors-section'>
              <div className='fiscalization__section-title'>
                <Text variant='body-tertiary1' shouldBeUppercase color={colors.gray[500]}>
                  {t('fiscalization:coffeeShops')}
                </Text>
              </div>
              {vendors && renderVendorsForm()}
            </div>
            <div className='fiscalization__baristas-section'>
              <div className='fiscalization__section-title'>
                <Text variant='body-tertiary1' shouldBeUppercase color={colors.gray[500]}>
                  {t('fiscalization:baristas')}
                </Text>
              </div>
              {baristas && renderBaristasForm()}
            </div>
          </div>
          <div className='fiscalization__button'>
            <Button type='submit'>
              {t('btn:save')}
            </Button>
          </div>
        </form>
        : <div>
          <Text variant='body-main1' color={colors.gray[400]}>{t('fiscalization:notIntegratedText')}</Text>
        </div>
      }
    </div>
  )
}

export default Fiscalization
